import React, {PureComponent} from 'react';
import {Input} from '..';

import styles from './styles';

const rangeInputProperties = {
  type: 'range',
  min: '-1.0',
  max: '1.0',
  step: '0.01'
};

export default class AdjustSubMenu extends PureComponent {

  handleChange = (property) => (value) => {
    const {onChange} = this.props;

    onChange(property, parseFloat(value));
  };

  render() {
    const {
      brightness = 0,
      contrast = 0,
      saturation = 0
    } = this.props;

    return (
      <div className={styles.subMenuContainer}>
        <div className={`${styles.subMenuSubsection} ${styles.subMenuOption}`}>
          <Input
            label='Brightness'
            value={brightness}
            onChange={this.handleChange('brightness')}
            {...rangeInputProperties}
          />
        </div>
        <div className={`${styles.subMenuSubsection} ${styles.subMenuOption}`}>
          <Input
            label='Contrast'
            value={contrast}
            onChange={this.handleChange('contrast')}
            {...rangeInputProperties}
          />
        </div>
        <div className={`${styles.subMenuSubsection} ${styles.subMenuOption}`}>
          <Input
            label='Saturation'
            value={saturation}
            onChange={this.handleChange('saturation')}
            {...rangeInputProperties}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdjustmentMenu/AdjustSubMenu.jsx